import classNames from "classnames";
import React from "react";
import { compose } from "redux";

import withTranslations from "../../../../../../hocs/withTranslations";
import withUserData from "../../../../../../hocs/withUserData";
import Loader from "../../../../common/Loader";
import LandingTypography from "../../../components/LandingTypography";
import useIsDesktop from "../../../hooks/useIsDesktop";
import PlanBox from "./PlanBox";
import useNextPlans from "../../../../../../hooks/useNextPlans";
const UpgradePlan = ({
  userData,
  locale,
  onSelect,
  translate,
  permissions
}) => {
  const isDesktop = useIsDesktop();

  const { response, loading, error } = useNextPlans({ permissions, locale });
  const plan = response?.[0];

  if (loading) {
    return <Loader small />;
  }

  if (error) {
    if (error?.response?.status === 404) {
      return <p>{translate("plans_upgrade-plan_no-plan")}</p>;
    }

    return <p>{translate("plans_upgrade-plan_error")}</p>;
  }

  return (
    <LandingTypography className={"plans landing-typography_dark"}>
      <div
        className={classNames({
          "grid gap-4 grid-cols-2": isDesktop,
          "flex flex-col gap-3": !isDesktop
        })}
      >
        {userData?.current_plan ? (
          <PlanBox
            isCurrentPlan={true}
            plan={userData.current_plan}
            isSelectedPlan={true}
          />
        ) : null}
        <PlanBox
          isAvailableInPlan
          isRecommendedPlan={plan.is_recommended}
          isHighlightedPlan={plan.is_highlighted}
          plan={plan}
          onSelect={() => onSelect(plan)}
          showBorder
        />
      </div>
    </LandingTypography>
  );
};

export default compose(withUserData, withTranslations)(UpgradePlan);
